import { useState } from "react";
import { CheckCircle2, Loader2, RefreshCw, AlertCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useContent } from "@/context/ContentContext";

export const InstagramSync = () => {
  const { content, refresh } = useContent();
  const s = content?.settings || {};
  const [syncing, setSyncing] = useState(false);

  const sync = async () => {
    setSyncing(true);
    try {
      const { data } = await api.post("/admin/instagram/sync");
      if (data.synced) {
        toast.success(`Synced ${data.count} posts from Instagram`);
        await refresh();
      } else {
        toast.error(data.reason || "Sync failed");
      }
    } catch (e) {
      toast.error("Sync failed — please try again");
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="glass mb-6 flex flex-wrap items-center justify-between gap-4 rounded-2xl p-5" data-testid="instagram-sync-bar">
      <div className="flex items-center gap-3">
        {s.instagram_connected ? (
          <CheckCircle2 className="h-5 w-5 text-green-600" aria-hidden="true" />
        ) : (
          <AlertCircle className="h-5 w-5 text-[#B38B2D]" aria-hidden="true" />
        )}
        <div>
          <p className="text-sm font-semibold text-[#1A1615]">
            {s.instagram_connected ? "Live sync connected" : "Live sync not configured"}
          </p>
          <p className="text-xs text-[#91837C]">
            {s.instagram_connected
              ? `Auto-syncs every 15 min${s.instagram_last_sync ? ` · last sync ${new Date(s.instagram_last_sync).toLocaleString()}` : ""}`
              : "Add your Instagram token + user ID in Site Settings → Instagram Auto-Sync, or curate posts manually below."}
          </p>
        </div>
      </div>
      <button onClick={sync} disabled={syncing} data-testid="instagram-sync-button" className="btn-gold px-5 py-2.5 text-xs disabled:opacity-60">
        {syncing ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> : <RefreshCw className="h-4 w-4" aria-hidden="true" />}
        {syncing ? "Syncing..." : "Sync Now"}
      </button>
    </div>
  );
};
